import styled from "styled-components";
import { Header_height } from "../../../style_config/VarStyle";
import { Section } from "../../../style_config/UseStyle";

export const ScontactWe = styled(Section)`
  padding-top: ${Header_height};
`;
